<div class="row" id="civil-email-confirm-modal">
    <div class="col-md-12">          
   
        <div class="modal-content">
            <div class="modal-header modal-header-no-banner" id="civil-email-modal-header">
                <h3 class="modal-title">Follow these steps to email case information:
                    <span class="pull-right row" style="padding-right: 20px;">
                        <button id="print.close" class="btn btn-primary " (click)="hideModal()" style="margin-bottom: 5px">
                            Close&nbsp;&nbsp;<span class="fa fa-close"></span>
                        </button>
                    </span>
                </h3>
            </div>
            <div class="modal-body">
                <br>
                <div class="row">
                    <ul>
                        <li class="col-xs-offset-2 col-xs-3 no-padding" (click)="goToStep(1)"
                             [ngClass]="{'clickable-step': currentStep > 1, 'active-step': currentStep === 1}"
                        ></li>
                        <li class="col-xs-3 no-padding" (click)="goToStep(2)"
                            [ngClass]="{'clickable-step': currentStep > 2, 'active-step': currentStep === 2}"
                        ></li>
                        <li class="col-xs-3 no-padding" (click)="goToStep(3)"
                            [ngClass]="{'active-step': currentStep === 3}"></li>
                    </ul>
                </div>
                <br>
                <div class="row">
                    <div class="col-xs-offset-1 col-xs-3 no-padding"
                         [ngClass]="{'active-step': currentStep === 1, 'clickable-step': currentStep > 1}"
                         (click)="goToStep(1)">
                        Step 1 - Confirm selection
                    </div>
                    <div id="print-step2-label" class="col-xs-3 no-padding"
                         [ngClass]="{'active-step': currentStep === 2, 'clickable-step': currentStep > 2}"
                         (click)="goToStep(2)">
                        Step 2 - Email
                    </div>
                    <div class="col-xs-3 no-padding"
                        [ngClass]="{'active-step': currentStep === 3}"
                        (click)="goToStep(3)">
                        Step 3 - Continue or clear history?
                    </div>
                </div>
                <br>
                <div *ngIf="currentStep === 1">
                        <div id='civil-email-table-wrapper-div' class="table-responsive">
                        <table class="table table-condensed" id="civil-email-table">
                            <thead>
                                <tr>
                                    <th class="col-md-8">Case Caption</th>
                                    <th class="col-md-2">Case County</th>
                                    <th class="col-md-2">Case Number</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let case of getCases()">
                                    <td>{{case.getCaseCaption()}}</td>
                                    <td>{{case.getCaseCounty()}}</td>
                                    <td>{{case.getCaseNumber()}}</td>
                                </tr>
                            </tbody>
                        </table>
                       </div>
                       <p id="civil-email-step1-table-footer-text">
                          <span>Case information will be provided in a Portable Document Format (PDF) file. <a class="anchor" (click)="preview(previewTemplate)">(Preview the PDF)</a></span>                            
                        </p>
                        <hr>    
                    <button class="btn  btn-primary center-block" id="civil-email-confirm" (click)="gotoEmailStep()"><span title="Step 1 - Confirm selection">Confirm</span></button>
                </div>
                <div *ngIf="currentStep === 2">

                    <div class="well" id="civil-email-noreply">
                        <p>The email will be sent from ciprs.noreply@nccourts.org with a subject of NC Courts Public Record Request. If you do not receive the email, check your spam or junk mail folder.</p>
                    </div>

                    <div class="container">
                        <form #emailForm [formGroup]="emailFormGroup" autocomplete="off" novalidate>
                            <div class="col-xs-4">
                                <div class="form-group has-feedback"
                                    [ngClass]="{'has-error':emailFormGroup.get('emailAddress').errors
                                                 && (submitted 
                                                    || emailFormGroup.get('emailAddress').touched
                                                    || emailFormGroup.get('emailAddress').dirty) }" 
                                    style="padding-top: 5px;">
                                    <label class="control-label" for="emailAddress">Email Address</label>
                                    <input name="emailaddress" 
                                          id="civil-email-address" 
                                          type="email" 
                                          (keypress)="updateValidity($event, 'emailAddress', '');"
                                          (blur)="updateValidity($event, 'emailAddress', '');"
                                          (focus)="updateValidity($event, 'emailAddress', '');"
                                          class="form-control"
                                          formControlName="emailAddress"
                                          appFocusable
                                          style="  padding-left: 4px; padding-right: 4px;"/>
                                        <div *ngIf="submitted">  
                                            <div class="control-label has-error" *ngIf="emailFormGroup.get('emailAddress').hasError('required')">
                                                Email Address is required.
                                            </div>
                                            <div class="control-label has-error" *ngIf="emailFormGroup.get('emailAddress').hasError('pattern')">
                                                Enter a valid email address.
                                            </div>
                                            <div class="control-label has-error" *ngIf="emailFormGroup.get('emailAddress').hasError('email')">
                                                Enter a valid email address.
                                            </div>
                                       </div>     
                                </div>
                            </div>
                            <div class="col-xs-8">
                                <p style="margin-bottom: 3px;">&nbsp;</p>                                                                
                                <button id="civil-email-send" class="btn btn-primary  pull-left" (click)="verifyAndSendEmail()"                                    
                                    popover="Please correct the highlighted errors." triggers="" placement="right" #pop="bs-popover"
                                    [disabled]="isHttpRequestInProgress()"
                                    (mouseenter)="(!emailFormGroup.get('emailAddress').valid && submitted)? pop.show() : pop.hide();"                                                 
                                    (mouseleave)="pop.hide();" style="margin-top:4px"><span title="Step 2 - Email"><i class="glyphicon glyphicon-envelope"></i>&nbsp;&nbsp;Send email</span>
                                    </button>                                    
                                <div [hidden]="!getValidEmailForDisplay()" style="font-size:medium; padding-top:7px;">                                    
                                    &nbsp;&nbsp;to <strong>{{getValidEmailForDisplay()}}</strong>
                                </div>   
                            </div>
                            <div *ngIf="isEmailRequestInProgress()" class="col-xs-12" style="width: 70%">
                                <h3 class="text-center">
                                    <p style="opacity: 0.6">Sending email...</p>
                                    <i class="fa fa-spinner fa-pulse fa-2x text-center"></i>
                                </h3>
                            </div>
                        </form>
                           <div class="col-xs-12" style="margin-top:10px; width:74%" [hidden]="!errors.length"> 
                                <alert type="danger" *ngFor="let error of errors">{{error}}</alert>
                           </div>    
                    </div>
                </div>
                <div *ngIf="currentStep === 3">
                    <alert type="info">
                        <p class="alert-text-color">The email has been successfully sent.</p>
                        <p class="alert-text-color">If you do not receive the email, check your spam or junk mail folder.
                            The email will be sent from ciprs.noreply@nccourts.org. This email account is not monitored.</p>
                    </alert>
                    Click 'Continue' if you want to keep using this application.
                    Click 'Clear History' to clear your search history and remove any data in your cart.
                    <hr>                    
                    <div class="center-block" style="width: 240px;">
                        <button class="btn  btn-primary" id="civil-email-continue" (click)="continue()"><span title="Step 3 - Continue or clear history?">Continue</span></button> 
                        <button class="btn  btn-primary" id="civil-email-clear-history" (click)="clearHistory()"><span title="Step 3 - Continue or clear history?">Clear History</span></button>
                    </div>    
                </div>
            </div>
        </div>

    </div>
</div>

<ng-template #previewTemplate>
    <div class="modal-body">
        <div *ngIf="pdfUri" id="pdf">
            <app-pdf [pdfUri]="pdfUri"></app-pdf>
        </div>
        <div *ngIf="isHttpRequestInProgress()">
            <h3 class="text-center">
                <p style="opacity: 0.6">Creating Preview...</p>                            
                <i class="fa fa-spinner fa-pulse fa-2x text-center"></i>                        
            </h3>                        
        </div>
        <div style="margin-top:10px" [hidden]="!errors.length">                      
            <alert type="danger" *ngFor="let error of errors">{{error}}</alert> 
            <button class="btn btn-primary  center-block" (click)="preview(previewTemplate)" id="civil-regenerate-preview-pdf">Try again</button>
        </div>
    </div>
    <div class="modal-footer">
        <div>
            <button id="civil-email-close-pdf-preview-button" class="btn btn-primary " (click)="previewPdfModalRef.hide()" style="margin-bottom: 5px"> Close Preview</button>
        </div>
    </div>
</ng-template>



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/email/email.component.html